<p-toast></p-toast>
<p-table #SequencesTable [value]="sequences" [totalRecords]="totalSequences" [rows]="10" [paginator]="true"
    selectionMode="single" [(selection)]="selectedSeqIDGroup" (onRowSelect)="getSequenceNumbersForID()"
    (onRowUnselect)="seqIDSequences = []" [lazy]="true" [loading]="loadingSequences"
    (onLazyLoad)="loadSequences($event)" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} groups"
    [showCurrentPageReport]="true">
    <ng-template pTemplate="caption">
        <div class="flex gap-5 justify-content-end">
            <div class="flex align-items-center gap-1">
                <p-checkbox [(ngModel)]="showAllSequences" [binary]="true" (click)="refreshSequences()"></p-checkbox>
                <label>Show All Sequences</label>
            </div>
            <span class="p-input-icon-left">
                <i class="pi pi-search"></i>
                <input pInputText type="text" placeholder="Search sequences"
                    (input)="SequencesTable.filterGlobal($any($event.target).value, 'contains')" />
            </span>
        </div>
    </ng-template>
    <ng-template pTemplate="header">
        <tr>
            <th pSortableColumn="cust_location">Location <p-sortIcon field="cust_location" /></th>
            <th pSortableColumn="seqid">Sequence ID <p-sortIcon field="seqid" /></th>
            <th pSortableColumn="unused_count">Unused Sequences <p-sortIcon field="unused_count" /></th>
            <th pSortableColumn="count">Total Sequence Numbers <p-sortIcon field="count" /></th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-sequence>
        <tr [pSelectableRow]="sequence">
            <td>{{ sequence.cust_location }}</td>
            <td>{{ sequence.seqid }}</td>
            <td>{{ sequence.unused_count }}</td>
            <td>{{ sequence.count }}</td>
        </tr>
    </ng-template>
</p-table>

<p></p>

<p-table #SeqIDNumsTable *ngIf="seqIDSequences.length > 0" [value]="seqIDSequences" [totalRecords]="totalSeqIDSequences"
    [rows]="10" [paginator]="true" [loading]="loadingSequences" dataKey="row_id" [globalFilterFields]="['seqnum', 'seq_status', 'cust_suite', 'cust_account']"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} numbers" [showCurrentPageReport]="true">
    <ng-template pTemplate="caption">
        <div class="flex">
            <div class="mr-auto flex gap-5">
                <p-button label="Archive All Inactive" (onClick)="updateSequencesStatus(seqIDSequences)"
                    [loading]="archivingSequences" [disabled]="!seqIDSequences.length || archivingSequences"></p-button>
                <p-button label="Refresh" (onClick)="refreshSequences()"
                    [loading]="archivingSequences" [disabled]="!seqIDSequences.length"></p-button>
            </div>
            <span class="p-input-icon-left ml-auto">
                <i class="pi pi-search"></i>
                <input pInputText type="text" placeholder="Search sequences"
                    (input)="SeqIDNumsTable.filterGlobal($any($event.target).value, 'contains')" />
            </span>
        </div>
    </ng-template>
    <ng-template pTemplate="header">
        <tr>
            <th>Location & Seq ID</th>
            <th pSortableColumn="seqnum">Sequence Number <p-sortIcon field="seqnum" /></th>
            <th pSortableColumn="seq_status">Status <p-sortIcon field="seq_status" /></th>
            <th>Suite - Account</th>
            <th></th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-sequence>
        <tr [pSelectableRow]="sequence">
            <td>{{ sequence.cust_location }} - {{ sequence.seqid }}</td>
            <td>{{ sequence.seqnum }}</td>
            <td>{{ sequence.seq_status }}</td>
            <td>{{ sequence.cust_suite && sequence.cust_account ? (sequence.cust_suite + '-'+ sequence.cust_account) : '' }}</td>
            <td>
                <div class="flex gap-2">
                    <p-button *ngIf="sequence.seq_status != 'archived'" icon="pi pi-lock" label="Archive" (onClick)="updateSequencesStatus([sequence])"
                        [loading]="archivingSequences" [disabled]="archivingSequences"></p-button>
                    <p-button *ngIf="sequence.seq_status == 'archived' || sequence.seq_status == 'on hold'" icon="pi pi-lock-open" label="Make Active" (onClick)="updateSequencesStatus([sequence], '')"
                        [loading]="archivingSequences" [disabled]="archivingSequences" [severity]="'success'"></p-button>
                    <p-button *ngIf="sequence.seq_status == ''" icon="pi pi-stop-circle" label="Hold" (onClick)="updateSequencesStatus([sequence], 'on hold')"
                        [loading]="archivingSequences" [disabled]="archivingSequences" [severity]="'warning'"></p-button>
                </div>
            </td>
        </tr>
    </ng-template>
</p-table>
<div class="footer-version">Version: {{version}} {{activeFile}}</div>
